export type Learnable = {
  learnableIdKey: number;
  sourceValue: string;
  /** Preference-aware: native script or romanization based on the user toggle. */
  targetValue: string;
  /** Always the native-script form when available (may match targetValue). */
  nativeScript?: string | null;
  /** Romanization / pinyin / romaji when available. */
  romanization?: string | null;
  growthLevel: number;
  known: boolean;
  difficult: boolean;
  nextReview: Date;
  dueForReview: boolean;
  audios: string[];
  learned: boolean;
  heard: boolean;
  used: boolean;
};

export interface UserLearnablesResponse {
  learnables: Learnable[];
  nextPageToken: string | null;
}
export interface RecentLearnable {
  id: number;
}

export interface RecentLearnablesResponse {
  learnables: RecentLearnable[];
}

export interface RecentLearnableDetail {
  learnableIdKey: number;
  romanization: string;
  sourceLanguageValue: string;
  targetLanguageValue: string;
  audios?: string[];
}

export interface RecentLearnableDetailsResponse {
  recentLearnables: RecentLearnableDetail[];
}

export enum PronunciationMode {
  BUDDIES_TAB = 'BUDDIES_TAB',
  MY_WORDS = 'MY_WORDS',
  /** "Say it yourself" widget inside a learn session; not counted as a pronunciation session start. */
  LEARN_SESSION = 'LEARN_SESSION',
}

export type LearnablePronunciationData = {
  learnableIdKey: number;
  sourceDefinitionValue: string;
  mainTargetValue: string;
  secondaryTargetValue: string | null;
  audios: string[];
};

export type LearnablePronunciationResult = 'pass' | 'fail' | 'almost';

export interface LearnablePronunciationScore {
  result: LearnablePronunciationResult;
  score: number;
}

export interface LearnablePronunciationResponse {
  score: LearnablePronunciationScore;
}
